import React from 'react'
import head from 'lodash/head'
import get from 'tcweb-material-components/core/poly/get'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import { cssToObj } from '../../utilities/helpers'

const useClasses = makeStyles(() => ({
    root: ({width, height, color, backgroundColor}) => ({
        height:  !height ? null : `${height}`,
        width:  !width ? null : `${width}`,
        padding: 0,
        color:  !color ? null : `${color}`,
        backgroundColor:  !backgroundColor ? null : `${backgroundColor}`,
    })
}))

const SeparatorSwap = ({ className='', data, options, attribs }) => {
    const _className = className.replace('wp-block-separator', '')
    const height = get(data, "height.divider.['']")
    const width = get(data, "width.divider.['']")
    const backgroundColor = head(get(attribs, 'class', '').match(/has-gears-[a-z]+-background-color/gi))
    const textColor = head(get(attribs, 'class', '').match(/has-gears-[a-z]+-color/gi))
    const styles = get(attribs, 'style', '').split(';')
    const _classes = useClasses({height, width, ...cssToObj(styles)})

    return (
        <div className={classnames(_className, backgroundColor, textColor, _classes.root)}>
            <Divider className={_classes.root}  />
        </div>
    )
}

export default SeparatorSwap

